import {
    mapBanners,
    mapArticles,
    mapWhereBuyProducts,
    mapReviewsInstagram,
    mapStretchings,
    mapTextCards,
    mapFaqSections,
    mapFaqElements,
} from "../mapping/optional";

export default function ($api) {
    return {
        /**
         * Получить баннеры
         * @return { Object }
         */
        getBanners() {
            return $api.get("api/banner/all?sorts[sort]=asc").then(mapBanners);
        },
        /**
         * Получить список статей "О нас"
         * @return { Object }
         */
        getMediaAboutUs(perPage = 30) {
            return $api
                .get(`api/article/all?sorts[sort]=asc&paging[per_page]=${perPage}`)
                .then(mapArticles);
        },
        /**
         * Получить общий список партнеров для покупки товаров бренда
         * @return { Object }
         */
        getWhereBuy() {
            return $api.get("api/where-buy/all").then(mapWhereBuyProducts);
        },
        /**
         * Получение разделов для FAQ
         * @returns { Object }
         */
        getFaqSections() {
            return $api.get("api/faq/structure?sorts[sort]=asc").then(mapFaqSections);
        },
        /**
         * Получение элементов для FAQ
         * @returns { Object }
         */
        getFaqElements() {
            return $api.get("api/faq/all?sorts[section.sort]=asc").then(mapFaqElements);
        },

        /**
         * Получение отзывов из инстаграма
         * @returns { Object }
         */
        getReviewsInstagram() {
            return $api.get("api/site-review/all").then(mapReviewsInstagram);
        },
        /**
         * Получение текстовых карточек
         * @param { String } section
         * @returns { Object }
         */
        getTextCards(section) {
            return $api
                .get(`api/text-card/all?filters[section][eq]=${section}&sorts[sort]=asc`)
                .then(mapTextCards);
        },
        /**
         * Получение растяжек для определенного города или региона
         * @returns { Object }
         */
        getStretchingsByCity(city) {
            return $api.post("api/stretching/getbycity", { city }).then(mapStretchings);
        },
    };
}
